import React, { useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [isError, setIsError] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage("Sending request...");
    setIsError(false);

    try {
      const response = await axios.post("/signup/forgot-password", { email });
      setMessage(response.data.message || "Reset link sent to your email.");
    } catch (error) {
      setIsError(true);
      setMessage("Failed to send reset link. Please try again.");
    }
  };

  return (
    <div className="login-wrapper">
      <h2>Reset Password</h2>
      <p style={{ marginBottom: "20px", fontSize: "14px", color: "#666" }}>
        Enter your email address and we'll send you a link to reset your password.
      </p>

      {message && (
        <p style={{ color: isError ? "red" : "green", marginBottom: "10px" }}>{message}</p>
      )}

      <form onSubmit={handleSubmit} className="login-form">
        <div className="input-group">
          <input
            type="email"
            placeholder="Enter your email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>
        <button type="submit">Send Reset Link</button>
      </form>
      <div style={{ marginTop: "20px", textAlign: "center" }}>
        <Link to="/login">Back to Login</Link>
      </div>
    </div>
  );
};

export default ForgotPassword;